module.exports = __webpack_public_path__ + "static/media/OMG.e2f8f7aa.svg";